export default "__VITE_ASSET__ZigCiAaX__"